import Gravity from '../../../../../gravity-global/assets/js/global-functions';

const sliderLogoCarousel = () => {
    document
        .querySelectorAll('.gg-logo-carousel .wp-block-statik-slider > .swiper')
        /* eslint-disable */
        .forEach((clientLogosCarousel) => {
            clientLogosCarousel.swiper.params.watchSlidesProgress = true;
            clientLogosCarousel.swiper.params.spaceBetween = 40;
            clientLogosCarousel.swiper.params.grabCursor = true;
            clientLogosCarousel.swiper.params.observer = true;
            clientLogosCarousel.swiper.params.observerParents = true;
            clientLogosCarousel.swiper.params.breakpoints = {
                /* eslint-enable */
                0: {
                    slidesPerView: 1,
                },
                640: {
                    slidesPerView: 3,
                },
                1025: {
                    slidesPerView: 4,
                },
            };
            clientLogosCarousel.swiper.update();
        });
};

Gravity.ready(sliderLogoCarousel);
